// Get country code from environment variable
const COUNTRY_CODE = import.meta.env.VITE_ServiceCountry || 'IN';
console.log(`🌍 Using country code: ${COUNTRY_CODE}`);

// Country-specific configurations
const COUNTRY_CONFIGS = {
    IN: {
        BASE_URL: "https://bijlee-customer-service-prodhps-fzhhejd5e8a3b0bx.centralindia-01.azurewebsites.net/api/v1",
        AGENT_ID: "94eccdb7494a2944b545329e266bc42f",
        DATABASES: [
            {
                id: "786f9272d4a16c675dc9d8e054f92a5c",
                name: "Husk Neuron DB India"
            }
        ]
    },
    NG: {
        BASE_URL: "https://bijlee-customer-service-ng-prodhps-dthhhpangjfcbrem.southafricanorth-01.azurewebsites.net/api/v1",
        AGENT_ID: "b62c8ac6b5aedfb1186468161d325374", 
        DATABASES: [
            {
                id: "7749b7e78faa24976b54a78910fdebed",
                name: "Nigeria Neuron DB"
            }
        ]
    }
} as const;

// Get current country configuration
const getCurrentCountryConfig = () => {
    const config = COUNTRY_CONFIGS[COUNTRY_CODE as keyof typeof COUNTRY_CONFIGS];
    if (!config) {
        console.warn(`Unknown country code: ${COUNTRY_CODE}, falling back to India (IN)`);
        return COUNTRY_CONFIGS.IN;
    }
    return config;
};

// Chatbot Configuration Constants
export const CHATBOT_CONFIG = {
    // API Endpoints
     INTERACT_URL: "https://api.zams.com/api/v1/interact",
    BASE_URL: getCurrentCountryConfig().BASE_URL,
    
    // API Keys and IDs (shared across countries)
    API_KEY: "e765e5767409c9cdb8585b133c8995ed2a2c3b90069e0d4f32029ae411e4e7c8",
    
    // Country-specific configuration
    AGENT_ID: getCurrentCountryConfig().AGENT_ID,
    DATABASES: getCurrentCountryConfig().DATABASES,
    
    // Current country info
    COUNTRY_CODE: COUNTRY_CODE,
    
    // UI Constants
    LOADING_MESSAGES: [
        "Fetching your data.",
        "Fetching your data..",
        "Fetching your data...",
        "Please wait.",
        "Please wait..",
        "Please wait...",
        "Almost done.",
        "Almost done..",
        "Almost done..."
    ],
    
    // Default Messages (country-specific)
    DEFAULT_BOT_MESSAGES: {
        WELCOME: COUNTRY_CODE === 'NG' ? "Hi! Ask me about your Nigeria HMG." : "Hi! Ask me about your India HMG.",
        WELCOME_HMG: COUNTRY_CODE === 'NG' ? "Hi, Ask me anything about Nigeria Husk HMG." : "Hi, Ask me anything about India Husk HMG.",
        ERROR: "Sorry, there was a problem with the API.",
        NO_MESSAGES: "Could not fetch messages.",
        LOADING_USER: "Loading user data..."
    },
    
    // Timing Configuration
    LOADING_INTERVAL: 780, // milliseconds
    UI_STABILITY_DELAY: 500, // milliseconds
    MESSAGE_LOAD_DELAY: 800, // milliseconds
    SCROLL_DELAY: 100, // milliseconds
    
    // Smart Scrolling Configuration
    QUESTION_SCROLL_OFFSET: 40, // px - space to leave above question for response
    RESPONSE_SCROLL_DELAY: 200, // milliseconds - delay before scrolling to response
    SMOOTH_SCROLL_DURATION: 300, // milliseconds
    MOBILE_SCROLL_OFFSET: 60, // px - extra space on mobile
    
    // Request Timeouts
    REQUEST_TIMEOUT: 30000, // 30 seconds
    
    // Retry Configuration
    MAX_RETRIES: 3,
    RETRY_DELAY: 1000 // milliseconds
} as const;

export type ChatbotConfigType = typeof CHATBOT_CONFIG;

// Helper functions
export const getChatbotConfig = () => CHATBOT_CONFIG;

export const getCountryInfo = () => ({
    code: COUNTRY_CODE,
    name: COUNTRY_CODE === 'NG' ? 'Nigeria' : 'India',
    agentId: CHATBOT_CONFIG.AGENT_ID,
    databases: CHATBOT_CONFIG.DATABASES
});

// Debug function to log current configurations
export const logChatbotConfig = () => {
    // console.log('🌍 Chatbot Configuration:', {
    //     country: getCountryInfo(),
    //     agentId: CHATBOT_CONFIG.AGENT_ID,
    //     databases: CHATBOT_CONFIG.DATABASES,
    //     interactUrl: CHATBOT_CONFIG.INTERACT_URL,
    //     baseUrl: CHATBOT_CONFIG.BASE_URL
    // });
};
